import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ChangeButtonView;
import React, { useEffect, useRef, useState } from 'react';
import { Button, Text } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import { IconCloseRoundStroked } from '@carnica/graphics';
import { AnimatePresence, motion } from 'framer-motion';
import { withRenderFlag } from '@beef/react';
import { REGION_TEXTS } from "./consts";
import { useClassOnScroll } from "../../../../hooks/useClassOnScroll";
import { Metric } from "../../../../metric";
import { EHeaderTheme } from "../../../../store/slices/layout";
import { useBreakpointContext } from "../../../../../../components/BreakpointProvider";
import style from "./styles.pcss";
var cn = classNames.bind(style);
export var ChangeButtonView = (_ChangeButtonView = {}, _defineProperty(_ChangeButtonView, EHeaderTheme.primary, 'secondary-invert'), _defineProperty(_ChangeButtonView, EHeaderTheme.secondary, 'secondary'), _defineProperty(_ChangeButtonView, EHeaderTheme.dark, 'tertiary'), _ChangeButtonView);
var CloseIcon = function CloseIcon(params) {
  return /*#__PURE__*/React.createElement(IconCloseRoundStroked, _extends({}, params, {
    color: "secondary-invert",
    size: 20,
    "data-t-id": "components-RegionConfirmationWrapper"
  }));
};

// #region Создание MotionDiv с расширенным типом

var BaseMotionDiv = motion.div;
export var MotionDiv = withRenderFlag(BaseMotionDiv);
// #endregion

export var RegionConfirmationWrapper = function RegionConfirmationWrapper(_ref) {
  var showConfirmation = _ref.showConfirmation,
    onChangeRegionClick = _ref.onChangeRegionClick,
    onApproveRegionClick = _ref.onApproveRegionClick,
    onCloseButtonClick = _ref.onCloseButtonClick,
    headerTheme = _ref.headerTheme,
    children = _ref.children;
  var _useBreakpointContext = useBreakpointContext(),
    isDesktop = _useBreakpointContext.isDesktop;
  var wrapperRef = useRef(null);

  // Стейт, определяющий, что компонент смонтирован (hydrated)
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoaded = _useState2[0],
    setIsLoaded = _useState2[1];
  useEffect(function () {
    setIsLoaded(true);
  }, []);
  useClassOnScroll(wrapperRef, cn({
    'region-confirmation--hidden': showConfirmation && !isDesktop
  }));

  // Если компонент ещё не смонтирован (SSR или до гидратации) – показываем скелетон
  if (!isLoaded) {
    return /*#__PURE__*/React.createElement("div", {
      className: cn('region-confirmation-skeleton'),
      ref: wrapperRef
    });
  }
  return /*#__PURE__*/React.createElement(AnimatePresence, {
    mode: "sync"
  }, /*#__PURE__*/React.createElement(MotionDiv, {
    animate: {
      opacity: 1,
      y: 0
    },
    className: cn('region-confirmation', "region-confirmation--".concat(headerTheme)),
    exit: {
      opacity: 0,
      y: -20,
      height: 10
    },
    initial: {
      opacity: 0,
      y: -10
    },
    key: "confirmation",
    ref: wrapperRef,
    shouldRender: showConfirmation,
    transition: {
      duration: 0.35
    },
    "data-t-id": "components-RegionConfirmationWrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('region'),
    "data-t-id": "components-RegionConfirmationWrapper"
  }, /*#__PURE__*/React.createElement(Text, {
    className: cn('region-location'),
    size: "xs"
  }, REGION_TEXTS.current), children), /*#__PURE__*/React.createElement("div", {
    className: cn('control-buttons')
  }, /*#__PURE__*/React.createElement(Metric, {
    asChild: true,
    data: REGION_TEXTS.approve,
    events: {
      headerMetric: ['handleChangeRegionClick']
    },
    mode: "click"
  }, /*#__PURE__*/React.createElement(Button, {
    className: cn('button'),
    onClick: onApproveRegionClick,
    size: "m",
    "data-t-id": "components-RegionConfirmationWrapper"
  }, REGION_TEXTS.approve)), /*#__PURE__*/React.createElement(Metric, {
    asChild: true,
    data: REGION_TEXTS.change,
    events: {
      headerMetric: ['handleChangeRegionClick']
    },
    mode: "click"
  }, /*#__PURE__*/React.createElement(Button, {
    className: cn('button'),
    onClick: onChangeRegionClick,
    size: "m",
    view: ChangeButtonView[headerTheme],
    "data-t-id": "components-RegionConfirmationWrapper"
  }, REGION_TEXTS.change))), /*#__PURE__*/React.createElement(MotionDiv, {
    shouldRender: !isDesktop
  }, /*#__PURE__*/React.createElement(Button, {
    className: cn('close-button'),
    iconLeft: CloseIcon,
    mode: "inline",
    onClick: onCloseButtonClick,
    "data-t-id": "components-RegionConfirmationWrapper"
  }))), /*#__PURE__*/React.createElement(MotionDiv, {
    animate: {
      opacity: 1,
      y: 0
    },
    className: cn('children-wrapper'),
    exit: {
      opacity: 0,
      y: 20
    },
    initial: {
      opacity: 0,
      y: 20
    },
    key: "children",
    shouldRender: !showConfirmation && isDesktop,
    style: {
      height: '16px'
    },
    transition: {
      duration: 0.3
    }
  }, children), /*#__PURE__*/React.createElement(MotionDiv, {
    shouldRender: !showConfirmation && !isDesktop
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('region-confirmation-skeleton', {
      'region-confirmation--collapsed': !showConfirmation
    }),
    ref: wrapperRef,
    "data-t-id": "components-RegionConfirmationWrapper"
  })));
};